"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecificEntity = void 0;
const generic_entity_1 = require("./generic-entity");
/**
 * This entity client is specific to a certain entity id.
 * Every operation made here operates on this specific instance.
 * See the generic counterpart client for non context calls like `create()`, `list()` etc.
 */
class SpecificEntity extends generic_entity_1.Entity {
    constructor(id, parentEntity, debug = false) {
        super(parentEntity, debug);
        this.id = id;
        if (!this.id) {
            throw new Error("SpecificEntity expects an id");
        }
    }
}
exports.SpecificEntity = SpecificEntity;
